import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
// import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
export interface PlaceSearchResult {
  address: string;
  location?: google.maps.LatLng;
  imageUrl?: string;
  iconUrl?: string;
  name?: string;
}

@Component({
  selector: 'app-autocomplete-map',
  standalone: true,
  imports: [CommonModule, GooglePlaceModule, MatFormFieldModule, MatInputModule, FormsModule, HttpClientModule],
  template: `
    <mat-form-field appearance="outline" color="white" >
      <input ngx-google-places-autocomplete (onAddressChange)="handleAddressChange($event)" [placeholder]="placeholder"  #inputField matInput />
      <!-- <input type="text" matInput #inputField [placeholder]="placeholder"> -->
    </mat-form-field>
  `,
  styles: [
    `
    .mat-form-field {
      width: 100%;
    }
    body:{
      color:white;
    }
    input::placeholder{
       color:white;
    }
  `,
  ]
})
export class AutocompleteMapComponent implements OnInit {
  @Input() placeholder: any;
  @ViewChild('inputField') inputField!: ElementRef;
  lat = 51.678418;
  lng = 7.809007;
  autocomplete: google.maps.places.Autocomplete | undefined;
  @Output() placeChanged = new EventEmitter<PlaceSearchResult>();

  title = 'google-places-autocomplete';
  constructor(private ngZone: NgZone, private http: HttpClient) { }

  ngOnInit(): void {
    // this.handleAddressChange()
  }
  userAddress: string = ''
  userLatitude: string = ''
  userLongitude: string = ''


  handleAddressChange(address: any) {
    const data = []
    console.log(address)
    data.push(address.formatted_address)
    console.log(data)
    this.userAddress = address.formatted_address
    this.userLatitude = address.geometry.location.lat()

    this.userLongitude = address.geometry.location.lng()
    console.log(this.userAddress)
    console.log(this.userLatitude)
    console.log(this.userLongitude)
  }

  ngAfterViewInit(): void {
    this.autocomplete = new google.maps.places.Autocomplete(this.inputField.nativeElement)
    console.log(this.autocomplete?.getPlace())

    this.autocomplete.addListener('places_changed', () => {
      this.ngZone.run(() => {
        const place = this.autocomplete?.getPlace();
        const result: PlaceSearchResult = {
          address: this.inputField.nativeElement.value,
          name: place?.name,
          location: place?.geometry?.location,
          imageUrl: this.getPhotoUrl(place),
          iconUrl: place?.icon,
        };
        console.log(result);
        this.placeChanged.emit(result);
      });
    })
  }

  getPhotoUrl(
    place: google.maps.places.PlaceResult | undefined
  ): string | undefined {
    return place?.photos && place?.photos.length > 0
      ? place?.photos[0].getUrl({ maxWidth: 500 })
      : undefined;
  }




}
